import quotesRender from "@/common/const/elementsList/quotesRender.const";
import { productsAndOtherStatusFilters } from "@/common/const/filter-options";
import { ColumnsStrategy } from "@/common/types";
import DocumentStatusSelect from "@/components/DocumentStatusSelect/DocumentStatusSelect";
import DocumentElementActions from "@/components/DocumentsList/Actions/DocumentElementActions";
import {
  DefaultHeadColumns,
  DefaultTextColumn,
  FilterSelect,
  TableCellWithTime,
} from "@/components/TableComponents";
import SortComponent from "@/components/TableComponents/Head/SortComponent";

const productsTable: ColumnsStrategy[] = [
  {
    label: <DefaultHeadColumns text="Product Name" key="productName" />,
    name: "productName",
    className:
      "!border-b-8 !border-gray-border !first:border-none first:!py-0 !h-10 !before:hidden",
    render: (value: string, record) => (
      <DefaultTextColumn text={value} key={record.id} />
    ),
  },
  {
    label: (
      <FilterSelect
        values={quotesRender}
        fieldName="filters-airxProductType"
        key="airxProductName"
      />
    ),
    name: "airxProductType",
    className:
      "!border-b-8 !border-gray-border !first:border-none !py-0 !h-10 !before:hidden",
    render: (value: string, record) => (
      <DefaultTextColumn
        text={
          quotesRender.find((productName) => productName.value === value)
            ?.label ?? null
        }
        key={record.id}
      />
    ),
  },
  {
    label: (
      <SortComponent
        key="uploadedAt"
        childKey="uploadedAt"
        title="Upload Date"
        tooltipVariants={["From newest to oldest", "From oldest to newest"]}
      />
    ),
    name: "uploadedAt",
    className:
      "!border-b-8 !border-gray-border !first:border-none !py-0 !h-10 !before:hidden",
    render: (value: string, record) => (
      <TableCellWithTime value={value} key={record.id} />
    ),
  },
  {
    label: (
      <FilterSelect
        values={productsAndOtherStatusFilters}
        fieldName="filters-status"
        key="status"
      />
    ),
    name: "status",
    className:
      "!border-b-8 !border-gray-border !first:border-none !py-0 !h-10 !before:hidden",
    render: (value: string, record) => (
      <DocumentStatusSelect
        id={record.id}
        value={value}
        options={productsAndOtherStatusFilters}
        key={record.id}
      />
    ),
  },
  {
    label: <DefaultHeadColumns text="Actions" key="actions" />,
    name: "id",
    className:
      "!border-b-8 !border-gray-border !first:border-none !py-0 !h-10 !before:hidden",
    render: (_, record) => (
      <DocumentElementActions data={record} key={record.id} />
    ),
  },
];
export default productsTable;
